var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6836 0.0776367H7.95632C6.75079 0.0776367 5.59464 0.556531 4.7422 1.40897C3.88976 2.26141 3.41087 3.41756 3.41087 4.62309V7.35036H0.683594V10.9867H3.41087V18.2595H7.04723V10.9867H9.7745L10.6836 7.35036H7.04723V4.62309C7.04723 4.38199 7.14301 4.15075 7.3135 3.98027C7.48398 3.80978 7.71522 3.714 7.95632 3.714H10.6836V0.0776367Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.af16e8486774ca3cc773932ae18395ab.svg";
export { ForwardRef as ReactComponent };